module.exports = require("opn");


//////////////////
// WEBPACK FOOTER
// external "opn"
// module id = 198
// module chunks = 0